export default "assets/images/icons/cloud-download-7a638fdb.svg";